import { useContext } from "react";
import IdentityDocumentContext from "./IdentityDocumentContext";

export default function useIdentityDocument() {
  return useContext(IdentityDocumentContext);
}
